export enum MapBundleMarker {
  SourceId = 'bundles-marker',
  PointId = 'bundles-marker-point',
  LabelId = 'bundles-marker-label',
  OrdersSourceId = 'bundled-orders-marker',
  OrdersPointId = 'bundled-orders-marker-point',
  OrdersLabelId = 'bundled-orders-marker-label',
  PolygonSourceId = 'bundles-marker-polygon-source',
  PolygonLayerId = 'bundles-marker-polygon-layer',
  PolygonOutlineId = 'bundles-marker-polygon-outline',
}
